module.exports = __webpack_public_path__ + "img/rushil.5f6ecd03.jpeg";